<template>
  <div id="image-crop">
    <Croppie :key="croppieKey" :image="overlay.data.image" :size="size" @crop="cropped" @cancel="setOverlay()" />
  </div>
</template>

<script>
import Mixin from './Mixin.js'

export default {
  name: 'ImageCropOverlay',
  mixins: [Mixin],
  data() {
    return {
      size: {
        height: 200,
        width: 200,
      },
      croppieKey: 0,
    }
  },
  methods: {
    cropped(result) {
      this.updateOptions({
        id: this.overlay.data.widget.id,
        path: '',
        value: {
          ...this.overlay.data.widget.options,
          originalUrl: this.overlay.data.widget.options.originalUrl,
          ...result,
        },
      })
      this.setOverlay()
      this.overlay.data.widget.onImgCropped()
    },
    updateViewport(orientation, value) {
      this.size[orientation] = parseInt(value, 10)
      this.croppieKey += 1
    },
  },
}
</script>

<style lang="scss" scoped>
#image-crop {
  height: 100vh;
  overflow-y: auto;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  background-color: white;
}
</style>
